"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNodeDescendantOf = exports.findNodeUpwards = exports.getChildren = exports.getAncestors = exports.getDescendants = exports.sortNodes = exports.getRootNode = exports.getNodeAndDescendants = exports.getParentsToChildrenMap = exports.getParentId = void 0;
const lodash_1 = require("lodash");
exports.getParentId = (node) => (node || {}).parent_id ||
    (node || {}).parent ||
    null;
exports.getParentsToChildrenMap = (nodes) => lodash_1.reduce(nodes, (nodeMap, node) => {
    const parentId = exports.getParentId(node);
    if (parentId) {
        const children = nodeMap[parentId] || [];
        children.push(node.id);
        nodeMap[parentId] = children;
    }
    return nodeMap;
}, {});
const getNodes = (nodes, startNode, parentsToChildren, shouldStopFn) => {
    const results = [startNode];
    const childIds = parentsToChildren[startNode.id];
    if (!shouldStopFn(startNode) && childIds) {
        const children = childIds.map(id => nodes[id]);
        return results.concat(lodash_1.flatten(lodash_1.map(children, child => getNodes(nodes, child, parentsToChildren, shouldStopFn))));
    }
    return results;
};
exports.getNodeAndDescendants = (nodes, startNodeId, shouldStopFn = () => false) => {
    const startNode = startNodeId
        ? nodes[startNodeId]
        : lodash_1.find(nodes, node => exports.getParentId(node) === null);
    const parentsToChildren = exports.getParentsToChildrenMap(nodes);
    return getNodes(nodes, startNode, parentsToChildren, shouldStopFn);
};
exports.getRootNode = (nodes) => lodash_1.find(nodes, (node) => exports.getParentId(node) === null);
const toMap = (nodes) => {
    if (Array.isArray(nodes)) {
        return lodash_1.reduce(nodes, (nodeMap, node) => {
            nodeMap[node.id] = node;
            return nodeMap;
        }, {});
    }
    return nodes;
};
exports.sortNodes = (nodes) => {
    const rootNode = exports.getRootNode(nodes);
    if (!rootNode) {
        return [];
    }
    return exports.getNodeAndDescendants(toMap(nodes), rootNode.id);
};
exports.getDescendants = (nodes, nodeId) => exports.getNodeAndDescendants(nodes, nodeId).slice(1);
exports.getAncestors = (nodes, startNodeId) => {
    const startNode = nodes[startNodeId];
    const parentId = exports.getParentId(startNode);
    if (parentId) {
        return exports.getAncestors(nodes, parentId).concat(nodes[parentId]);
    }
    return [];
};
exports.getChildren = (nodes, nodeId) => {
    const parentChildrenMap = exports.getParentsToChildrenMap(nodes);
    const children = parentChildrenMap[nodeId] || [];
    return children.map(id => nodes[id]);
};
exports.findNodeUpwards = (nodes, startNodeId, isFoundFn) => {
    const startNode = nodes[startNodeId];
    const parentId = exports.getParentId(startNode);
    if (!parentId || isFoundFn(startNode)) {
        return startNode;
    }
    const parent = nodes[parentId];
    return parent ? exports.findNodeUpwards(nodes, parent.id, isFoundFn) : undefined;
};
exports.isNodeDescendantOf = (currentNode, pathNode, flowNodes) => {
    if (!currentNode || !pathNode || lodash_1.isEmpty(flowNodes)) {
        return false;
    }
    if (pathNode === currentNode) {
        return false;
    }
    const nodeAndDescendants = exports.getNodeAndDescendants(flowNodes, pathNode.id);
    return nodeAndDescendants.includes(currentNode);
};
